import { SETTINGS_GET, SETTINGS_SET } from '../actions/settings'
import apiCall from './call'

const state = {
  //
}

const actions = {
  [SETTINGS_GET]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      let url = 'settings/' + data.settingsKey

      apiCall({ url: url })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [SETTINGS_SET]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      let url = 'settings/' + data.settingsKey

      apiCall({ url: url, data: { value: data.settingsValue }, method: 'POST' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const mutations = {
  //
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js